module.exports = __webpack_public_path__ + "img/65.daa81636.jpg";